import { EnvironmentName } from '@thesavingsgroup/config/types/EnvironmentName';

export const APPLICATION_CREATE_NEW_APP_DELAY_DAYS = 30;
export const AWS_ENVIRONMENT_NAME_MAP: Record<
  EnvironmentName,
  EnvironmentName
> = {
  dev: 'dev',
  local: 'dev',
  prod: 'prod',
  qa: 'dev',
  stg: 'stg',
};
export const AWS_LAMBDA_ENVIRONMENT_NAME_MAP: Record<
  EnvironmentName,
  EnvironmentName
> = {
  dev: 'qa',
  local: 'qa',
  prod: 'prod',
  qa: 'qa',
  stg: 'stg',
};
export const DEFAULT_BRAND = 'AUTOPAY';
export const DEFAULT_INCOME_DURATION_IN_MONTHS = 6;
export const DEFAULT_LEAD_CHANNEL_CODE = 'CONSUMER_PORTAL';
export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 25;
export const DEFAULT_RESIDENCE_DURATION_IN_MONTHS = 12;
export const DEFAULT_RESIDENCE_MONTHLY_PAYMENT_AMOUNT = 0;
export const DEFAULT_SERVICE_PORT = 8041;
export const DEFAULT_SESSION_SECRET_KEY =
  'qmbXLCRb&hW9sFxdoETxmzZGhFu82yWLNyQKFWPvHqYC';
export const DEFAULT_SESSION_TTL = 86400 * 180; // Default: 180 days (~6 months)
export const DEFAULT_SOURCE = 'LOS';
export const DEFAULT_UI_BRAND_ID = 'CONSUMER_PORTAL';
export const DEFAULT_VEHICLE_INFORMATION_PAYLOAD_VERSION = '1.0.0';
export const DOCUMENTS_TERMS_AND_CONDITIONS_OPT_IN_PRODUCT = 'RE_F_AND_I';
export const DOCUMENTS_TOKEN_ISSUER = 'CONSUMER_PORTAL';
export const DOCUMENTS_TOKEN_SCOPE = 'refandi';
export const EXPECTED_VERSION_FORMAT = /^v[\d]{4}$/;
export const FALLBACK_REDIRECT_URL = 'https://apply.autopay.com/savings';
export const FOUR_YEARS_IN_DAYS = 1460;
export const FOUR_YEARS_IN_MONTHS = 48;
export const MAXIMUM_MAKE_LENGTH = 255;
export const MAXIMUM_MODEL_LENGTH = 255;
export const MAXIMUM_PAYOFF_AMOUNT = 999_999;
export const MAXIMUM_PER_PAGE = 100;
export const MAXIMUM_PURCHASE_PRICE = 999_999;
export const MAXIMUM_TRIM_LENGTH = 255;
export const MAXIMUM_VEHICLE_YEAR = new Date().getFullYear() + 1;
export const MAXIMUM_VIN_LENGTH = 17;
export const METADATA_SCHEMA_VERSION = '1.4.0';
export const MILEAGE_PER_MONTH = 1000;
export const MINIMUM_VEHICLE_YEAR = 1913;
export const MINIMUM_VIN_LENGTH = 11;
export const MINIMUM_INCOME_DURATION_IN_MONTHS = 6;
export const MINIMUM_INCOME_DURATION_FOR_PREVIOUS_IN_MONTHS = 12;
export const MINIMUM_RESIDENCE_DURATION_IN_MONTHS = 12;
export const ONE_MONTH_IN_DAYS = 30;
export const ONE_YEAR_AND_SIX_MONTHS_IN_DAYS = 545; // 365 + 180
export const ONE_YEAR_IN_DAYS = 365;
export const ONE_YEAR_IN_MONTHS = 12;
export const REDIRECT_LINK_DEFAULT_LEAD_CHANNEL = 'AUTOPAY_CK_PRP_LINK';
export const REDIRECT_LINK_DEFAULT_LEAD_ORGANIZATION = 'AUTOPAY_CK_PRP';
export const SIX_MONTHS_IN_DAYS = 180;
export const THREE_MONTHS_IN_DAYS = 90;
export const THREE_YEARS_IN_DAYS = 1095;
export const THREE_YEARS_IN_MONTHS = 36;
export const TWO_MONTHS_IN_DAYS = 60;
export const TWO_YEARS_IN_DAYS = 730;
export const TWO_YEARS_IN_MONTHS = 24;
export const UNLEASH_ENVIRONMENT_MAP: Record<EnvironmentName, string> = {
  dev: 'development',
  local: 'local',
  prod: 'production',
  qa: 'qa',
  stg: 'stage',
};
export const USER_ACTIVATE_TOKEN_ISSUER = 'CONSUMER_PORTAL';
export const USER_ACTIVATE_TOKEN_SCOPE = 'activate';
